import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createSite, deleteSite, fetchSites, updateSite } from '../api';

export const KEY_SITES = ['admin', 'sites'] as const;

export const useSites = () =>
  useQuery({ queryKey: KEY_SITES, queryFn: fetchSites, staleTime: 30_000 });

export function useCreateSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createSite,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY_SITES }),
  });
}

export function useUpdateSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: import('@app/contracts').SiteUpdateInput }) =>
      updateSite(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY_SITES }),
  });
}

export function useDeleteSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteSite,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY_SITES }),
  });
}
